function randomNumber() {
  return Math.floor(Math.random() * 10);
}

export { randomNumber };
